import React from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { change, FieldArray, formValueSelector } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import { renderFormFields } from "containers/ProductsAndSubscriptions/Categories/utils"
import BottomNavigation from "components/BottomNavigation"
import { updateSocialProfileSettings } from "store/actions"

const SocialProfileSetupTab = ({
  change,
  handleBack,
  socialProfileSettings,
  updateSocialProfileSettings,
  formFields,
  handleNext,
}) => {
  const handleSave = () => {
    const fields_to_display = formFields
      ?.filter(field => field?.checked)
      ?.map(field => ({ key: field?.name, label: field?.label }))
    const required_fields = formFields
      ?.filter(field => field?.required)
      ?.map(field => field?.name)

    updateSocialProfileSettings({
      fields_to_display,
      required_fields,
      vendor_id: socialProfileSettings?.vendor_id,
    })
  }

  return (
    <React.Fragment>
      <Card>
        <CardHeader className="mt-3">
          <h4>CUSTOMIZE SOCIAL PROFILE</h4>
        </CardHeader>
        <CardBody className="shadow-sm py-1">
          <Row>
            <Col>
              <span>
                You have to select which fields will be displayed in social
                profile screen from the app and also which ones should be
                required or not.
              </span>
            </Col>
          </Row>
          <Row>
            <Col xs="auto" className="my-1">
              <FieldArray
                name="formFields"
                component={renderFormFields}
                rerenderOnEveryChange={true}
                change={change}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <BottomNavigation
        handleBack={handleBack}
        handleSave={handleSave}
        handleNext={handleNext}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.PLATFORM_SETTINGS)

const mapStateToProps = state => ({
  socialProfileSettings: state.PlatformSettings.socialProfileSettings,
  formFields: selector(state, "socialProfile.formFields"),
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.PLATFORM_SETTINGS, `${field}`, value)),
  updateSocialProfileSettings: values =>
    dispatch(updateSocialProfileSettings(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SocialProfileSetupTab)
